export var START_KEY = '__start__';
export var END_KEY = '__end__';
export var WATERFALL_VALUE = '__waterfall_value__';
